export const isPaymentRoute = (pathname: string): boolean => {
    const routes = ['/payment', '/[brand]/payment'];
    return routes.some((route) => pathname.startsWith(route));
};
